const en = {
  common: {
    loading: "Loading...",
    please_wait: "Please wait",
    kent_project: "A product of KenT Project"
  },
  nav: {
    home: "Home",
    gallery: "Gallery",
    guide: "Guide",
    create_frames: "Create Frames",
    how_to_use: "How to use",
    about: "About",
    contact: "Contact"
  },
  home: {
    welcome_to: "Welcome to",
    subtitle: "Take photos online with hundreds of trending 2026 frames. No app download, no watermark, and private by design — capture, then share instantly!",
    start_capture: "START SHOOTING",
    view_gallery: "VIEW GALLERY",
    follow_social: "Follow KenT Photobooth on Facebook & TikTok",
    social_popup_title: "Follow us!",
    social_popup_desc: "Connect with KenT Photobooth on Facebook and TikTok to get the latest updates and frames.",
    explore_now: "Explore now",
    memory_corner: "Memory Corner",
    how_to_shoot: "How to take photo booth pictures?",
    card1_title: "Choose a frame",
    card1_desc: "Select a frame, click 'Continue' and start shooting!",
    card2_title: "Take photos",
    card2_desc: "After shooting, click continue to go to the next page. If you want to retake a single photo, click on it and press retake.",
    card3_title: "Choose frame and Download",
    card3_desc: "Choose a color or a frame for the photo, click 'Download' to share.",
    feature_title: "Professional photobooth at home for completely free",
    feature_sub1: "Smooth experience",
    feature_sub2: "No registration required",
    feature_sub3: "No ads",
    feature_sub4: "No watermark",
    feature_layout_title: "Multiple layouts and frames",
    feature_layout_desc: "Get creative with a wide variety of layouts and frames, from classic to modern, making your photos more unique than ever.",
    feature_filter_title: "Beautiful photobooth filters",
    feature_filter_desc: "Specially tuned color filters for photobooth style, making skin look radiant and colors crystal clear.",
    feature_share_title: "One click to share with everyone",
    feature_share_desc: "Easily download or quickly share via QR code, spreading joy with friends and family in an instant.",
    shoot_now: "Shoot now"
  },
  gallery: {
    title: "Gallery",
    heading: "Your Moments 💙",
    photo_count: "photos",
    secure: "100% Secure",
    free: "Free",
    send_photo: "Send us your photos!",
    description: "The most authentic photos sent from users — each one is a memorable moment. Except for the QR code sharing feature, the website will not store any of your photos, so rest assured 100%! You can choose to send it to us when downloading or by clicking the button next to it!",
    loading_more: "Loading more...",
    no_photos: "No photos yet"
  },
  guide_create: {
    title: "Frame Creation Guide",
    subtitle: "How to Create Frames using Canva",
    desc1: "We have prepared basic frames for you to get creative! 🎨",
    desc2: "The frames you create can be used with the custom frame feature!",
    step1_title: "Choose a Canva Frame Template",
    template4: "4-Photo Template (1x4)",
    template4_desc: "For vertical 4-photo layout.",
    template6: "6-Photo Template (2x3)",
    template6_desc: "For 6-photo layout.",
    template2: "2-Photo Template (2x2)",
    template2_desc: "For 2-photo layout.",
    step2_note_title: "Important note:",
    step2_note_desc: "Keep the colored area in the small frame (gray, blue, or the square meant to hold the photo) in the middle as the background for removal.",
    step2_tip: "💡 You can download the frame with only the background first, remove the background, and then put it back on Canva to add stickers (to avoid messy removal on highly complex stickers)",
    step3_title: "Download Image",
    step3_desc: "After designing, download the newly created frame to your device to prepare for use!",
    step4_title: "Remove Background using Photopea",
    step4_desc: "🖼️ Guide to removing background on Photopea",
    step4_li1: "Go to Photopea.com",
    step4_li2: "Drag the image file or use 'Ctrl + O' to open the image you just downloaded from Canva.",
    step4_li3: "Select the Magic Wand tool.",
    step4_li4: "Click on the colored area in the middle to select it.",
    step4_li5: "Press the Delete key on your keyboard.",
    step4_li6: "Go to File > Export as > PNG. Click Save.",
    step5_title: "Completion & Community",
    step5_desc1: "✨ Now you have a transparent PNG file! Go back to the website, click the \"Upload Custom Frame\" button on the frame selection page and upload it for private use.",
    step5_desc2: "🔒 The website does not store any images, so you can use it with peace of mind !!!",
    step5_community: "Let's Build the Community Together",
    step5_community_desc1: "If you have created a really beautiful and satisfying frame, and want to share it for everyone to use on this website, don't hesitate to send your PNG file to us via Instagram.",
    step5_community_desc2: "💜 Your contribution will enrich our frame gallery. Thank you so much! ❤️"
  },
  guide_use: {
    title: "How To Use",
    subtitle: "With just 5 simple steps, you can create unique photobooth pictures and keep memories with friends!",
    step: "Step",
    step1_title: "Start your journey",
    step1_desc: "On the home page, click the \"Start shooting\" button. Don't forget to grant camera access to your browser! (All images are processed locally on your device for maximum privacy).",
    step2_title: "Choose a layout",
    step2_desc: "Browse and select the photo layout you like best. Many cute layouts are waiting for you.",
    step3_title: "Strike a pose & Shoot",
    step3_desc: "Feel free to choose suitable color filters or effects. Adjust your camera angle, strike your best poses, and start taking photos! After capturing all shots, click \"Continue\".",
    step4_title: "Decorate your frame",
    step4_desc: "Make your photo stand out by choosing a background color that matches your style, or directly select eye-catching available Frames from our gallery.",
    step5_title: "Save & Share",
    step5_desc: "Your masterpiece is ready! You can immediately download the high-quality image to your device, or use the \"Share QR\" feature to quickly send it to your friends to scan and download.",
    ready: "Are you ready?",
    create_frame_btn: "Create your own frame",
    start_btn: "Start shooting now",
    faq_title: "Frequently Asked Questions",
    q1: "What is KenT Photobooth?",
    a1: "KenT Photobooth is a web application that allows you to take photobooth-style photos directly in your computer or phone browser without installing any software.",
    q2: "Does the website store my photos?",
    a2: "Not at all. All photo processing happens directly in your browser (Client-side). Photos are only temporarily stored on the server when you actively choose the 'Share QR' feature to download photos to your phone.",
    q3: "Is QR sharing safe?",
    a3: "Very safe. Sharing links automatically expire and all data on the server is cleared after 1 week. No one can view your photos without your specific link or QR code.",
    q4: "Can I use my own designed frames?",
    a4: "Yes! You can visit the 'Create Frame' section to see instructions on how to create your own frames using Canva and Photopea, then upload them for private use.",
    q5: "Is the website free?",
    a5: "The website is 100% free. You can support me (Donate) by clicking the 'Contact' section to help me maintain the server!",
    steps_title: "Execution Steps",
    still_need_help: "Still need help?",
    help_desc: "If you encounter any issues while using or want to contribute ideas, don't hesitate to message us!",
    contact_now: "Contact now"
  },
  contact: {
    donate_title: "☕ Buy me a coffee!",
    donate_desc: "Help me stay motivated to maintain the server and develop more new features! 💕",
    admin_badge: "Admin",
    contact_info: "Contact Information",
    contact_desc: "I coded this Photobooth website as a gift for my cute mhoa 🥰💕",
    fb_page1: "Facebook Page",
    fb_page2: "Facebook Page"
  },
  about: {
    welcome: "Welcome to KenT PhotoBooth",
    title1: "Capture the moments",
    title2: "Your own way",
    desc: "We bring a professional photo booth experience right to your browser. Fast, private, and completely free.",
    team_title: "Development Team",
    author_title: "Author: Que Minh Thanh (Dev 2k8)",
    author_desc: "A young developer born in 2008 who laid the foundation and built the entire KenT PhotoBooth system. With a passion for technology and creativity, KenT Software has realized the idea of a convenient online photobooth for everyone.",
    designer_title: "Frame Designers: Que Minh Thanh, Que Mai Huong",
    designer_desc: "The team behind the sparkling and diverse frame templates. Meticulous in every detail to ensure each of your photos becomes special and bears your personal mark.",
    journey_title: "Development Journey",
    m1_title: "Project started",
    m1_desc: "Laying the first bricks for the idea of a digital photo booth. The project started with the desire to bring joy through every frame.",
    m2_title: "First Final Version",
    m2_desc: "After nearly 2 months of hard development, the first complete version was officially born, marking an important milestone in the creative journey.",
    m3_title: "Public online",
    m3_desc: "Officially bringing the project online. Initially built from pure HTML, CSS, and JS, operating actively in the first 3 weeks.",
    m4_title: "Restructuring & React",
    m4_desc: "A major turning point when the entire source code was converted to the modern React platform. At the same time, establishing Facebook KenT Photobooth to connect users.",
    m5_title: "Official relaunch",
    m5_desc: "Officially returning with a new look, outstanding performance, and stable operation until today.",
    features_title1: "Maximum Security",
    features_desc1: "Your data is strictly protected and processed on your own device. Photos are only stored on the server when you use the QR sharing feature.",
    features_title2: "Massive Frame Library",
    features_desc2: "Constantly updated with the latest trends: Y2K, Aesthetic, Vintage, and more.",
    features_title3: "Completely Free",
    features_desc3: "Experience all premium features without any cost. Your joy is our motivation.",
    features_title4: "Instant Sharing",
    features_desc4: "Create QR codes and share photos with friends in seconds. Convenient and super fast.",
    features_title5: "Seamless Experience",
    features_desc5: "Optimized interface, works smoothly on all devices from mobile to desktop.",
    features_title6: "Crystal Clear Quality",
    features_desc6: "Photos are exported in high resolution, ensuring every detail of your memories remains vibrant and sharp.",
    cta_title: "Ready for beautiful photos?",
    cta_desc: "Join the KenT PhotoBooth user community and start creating today.",
    cta_btn: "Start shooting photos",
    users: "1000+ Users"
  },
  photo_layout: {
    title: "Choose your favorite layout!",
    subtitle: "We will add more frames in the future. 🌸",
    photos: "photos",
    start_btn: "Start Shooting",
    alert_select: "Please select a layout before continuing.",
    layout_prefix: "Layout",
  },
  take_photo: {
    record_video_btn: "Record Video",
    settings_btn: "Settings",
    layout_label: "Layout:",
    reselect_layout: "Reselect Layout",
    confirm_reselect: "Are you sure you want to reselect layout? Captured photos will be lost.",
    upload_photos: "Upload Photos",
    camera: "Camera",
    confirm_upload: "Are you sure you want to switch to upload mode? Captured photos will be lost.",
    confirm_exit_video_mode: "Do you want to switch modes before finishing capture? Current photos will be lost.",
    flash_toggle: "Toggle Flash effect",
    flip_camera: "Flip Camera (Mirror)",
    alert_camera_off: "Please turn on camera first!",
    confirm_retake: "Are you sure you want to retake photo #",
    confirm_change: "Do you want to change this photo?",
    alert_need_photos: "Need {requiredPhotos} photos to continue!",
    filter_normal: "Normal",
    filter_gray: "Gray",
    filter_sepia: "Sepia",
    filter_bright: "Bright",
    filter_contrast: "Sharp",
    filter_blur: "Blur",
    slot: "Slot",
    support_off: "Support Off",
    support_on: "Support Shooting",
    capturing: "Capturing...",
    processing: "Processing...",
    processing_subtitle: "Your photos are being processed...",
    manual_capture: "Manual",
    retake_photo_btn: "Retake Photo #",
    auto_capture: "Auto",
    continue_btn: "Continue",
    confirm_retake_all: "Are you sure you want to retake all? Captured photos will be lost.",
    retake_all_btn: "Retake All",
    countdown_label: "⏱️ Countdown:",
    seconds: "sec",
    filter_title: "Filters",
    effect_title: "Effects",
    effect_notice: "(Visible after capture)",
    settings_title: "Camera Settings",
    select_camera: "Select Camera:",
    camera_label: "Camera",
    switch_camera_tip: "Switch Front/Back Camera",
    mirror_label: "Mirror Camera",
    sound_label: "Enable Capture Sound",
    flash_screen_label: "Enable Flash Effect",
    live_gif_label: "Record video with photos (5s)",
    close_btn: "Close",
    edit_title: "Edit Photo",
    cancel_btn: "Cancel",
    apply_btn: "Apply",
    crop_tip: "Crop carefully!!!",
    support_modal_title: "Select Support Frame",
    support_modal_desc: "Virtual frame on camera for alignment. Real frame will be chosen at the end.",
    search_placeholder: "Search frames...",
    clear_support_btn: "Turn off current support frame"
  },
  result: {
    thanks: "Thank you for using our web app!",
    confirm_retake: "Do you want to retake?",
    upload_success: "Thank you for sharing your photo!",
    upload_error: "Error uploading photo.",
    no_image_to_share: "No image found to share.",
    error_load_frame: "Cannot load custom frame!",
    error_load_img: "Cannot load frame:",
    error_invalid_file: "Invalid file! Please select a PNG image.",
    cancel_btn: "Cancel",
    photo_num: "Photo",
    scroll_tip: "Scroll down to decorate your photo frame",
    bg_color: "Background",
    photo_mode: "Photo Mode",
    photo_frame: "Photo Frame",
    use_custom_frame: "Custom Frame",
    search_frame_placeholder: "Search frames...",
    complete_btn: "Complete",
    retake_btn: "Retake",
    contribute_title: "Contribute to Library",
    contribute_question: "Would you like to share your photo with our gallery?",
    frame_upload_success: "Custom frame uploaded successfully!",
    qr_success: "QR code created!",
    qr_error: "Cannot create QR. Please try again.",
    zoom_photo: "Zoom photo",
    share_qr_label: "Share QR",
    creating_qr: "Creating...",
    create_qr_btn: "Create QR",
    share_your_photo: "Share Your Photo",
    share_via_qr: "Share via QR",
    generate_qr: "Generate QR",
    select_download_title: "Select photos to download",
    download_photo_title: "Download Photo",
    save_all: "Save Strip",
    save_one: "Save Single",
    download_btn: "Download",
    video_processing: "Processing...",
    download_video_btn: "Download video",
    close_btn: "Close",
    your_photo_title: "Your Photo",
    loading_photo: "Loading photo...",
    one_photo: "1 photo",
    two_photos: "2 photos",
    custom_frame_title: "Upload custom frame",
    frame_uploaded: "Frame uploaded",
    drag_drop_tip: "Drag & drop image here",
    or_click_tip: "or click to select file",
    yes_create_qr: "Yes & Create QR",
    no_continue_qr: "No, just create QR",
    generating_qr: "Generating QR Code",
    generating_qr_desc: "We are generating a QR code for you to share your photo, please wait a moment!",
    your_qr_title: "Your QR Code",
    scan_qr_tip: "Scan QR code with your phone camera to download photo!",
    or_copy_link: "Or copy link:",
    copied_link: "Link copied!",
    storage_notice: "Note: This photo exists for 1 week. After that, it will be automatically deleted!",
    storage_note_title: "Note",
    storage_note_part1: "This photo exists for",
    storage_note_duration: "1 week",
    storage_note_part2: ". After that, it will be automatically deleted!",
    thanks_title: "Thank you!",
    share_invite: "Please share with everyone!",
    frame_update_notice: "New frames will be updated constantly ^^",
    contribute_question_alt: "Would you like to contribute this photo to the public collection?",
    yes_contribute: "Yes, contribute",
    no_thanks: "No, thanks",
    contribute_success: "Contributed successfully!",
  },
  share_view: {
    not_found: "Photo does not exist or has expired",
    load_error: "Cannot load photo. Please try again.",
    loading_title: "Loading photo...",
    loading_sub: "Fetching photo from server",
    error_title: "Photo Not Found",
    home_btn: "Back to Home",
    header_title: "Share Photo",
    header_sub: "Shared from KenT Photobooth",
    one_photo: "1 photo",
    two_photos: "2 photos",
    tooltip_not_ready: "2-photo version not ready",
    tooltip_ready: "Show 2 photos",
    tag_layout: "Layout:",
    tag_frame: "Has Frame",
    tag_valid: "Valid for 1 week",
    download_title: "Download",
    downloading: "Downloading...",
    download_btn: "Download Now",
    cta_text: "Do you want to create your own photobooth?",
    cta_btn: "Create yours",
    notice: "Notice:",
    notice_server: "This photo is only available for 1 week and will be automatically deleted.",
    notice_local: "This link only works while the sharer is on the website. Please download now!",
    tip: "Tip: Save the photo to keep your beautiful memories!",
    created_by: "Created by",
    preparing: "Preparing photo...",
    preparing_sub: "Optimizing PNG format for you.",
    select_download_title: "Select photos to download",
    photo_num: "Photo",
    cancel_btn: "Cancel",
    download_btn: "Download",
    custom_frame_title: "Upload custom frame",
    frame_uploaded: "Frame uploaded",
    drag_drop_tip: "Drag & drop image here",
    or_click_tip: "or click to select file",
    contribute_title: "Contribute to gallery",
    contribute_question: "Would you like to share your photo with our gallery?",
    yes_create_qr: "Yes & Create QR",
    no_continue_qr: "No, just create QR",
    generating_qr: "Generating QR Code",
    generating_qr_desc: "We are generating a QR code for you to share your photo, please wait a moment!",
    your_qr_title: "Your QR Code",
    scan_qr_tip: "Scan QR code with your phone camera to download photo!",
    or_copy_link: "Or copy link:",
    copied_link: "Link copied!",
    storage_notice: "Note: This photo exists for 1 week. After that, it will be automatically deleted!",
    close_btn: "Close",
    thanks_title: "Thank you!",
    share_invite: "Please share with everyone!",
    frame_update_notice: "New frames will be updated constantly ^^",
    contribute_question_alt: "Would you like to contribute this photo to the public collection?",
    yes_contribute: "Yes, contribute",
    no_thanks: "No, thanks",
    contribute_success: "Contributed successfully!",
    your_photo_title: "Your Photo",
    loading_photo: "Loading photo...",
    one_photo: "1 photo",
    two_photos: "2 photos",
    download_photo_title: "Download Photo",
    save_all: "Save Strip",
    save_one: "Save Single",
    creating_qr: "Creating...",
    create_qr_btn: "Create QR",
    share_your_photo: "Share Your Photo",
    share_via_qr: "Share via QR"
  },
  welcome_modal: {
    title: "Welcome!",
    timer_title: "Choose timer",
    timer_body: "You can choose the countdown time for each shot!",
    session_title: "Consecutive shots",
    session_body: "This session will take multiple photos consecutively — strike your best poses! 🌟",
    privacy_title: "Privacy note",
    privacy_body: "Unless you use the sharing feature, the website will not store any photos you take.",
    start_btn: "START"
  },
  footer: {
    description: "Photobooth is a place to preserve memorable moments with high image quality, friendly interface and many creative effects for all ages.",
    contact: "Contact",
    total_visits: "Total Visits:"
  }
};

export default en;
